let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("j9dKi")).then(() => parcelRequire('ktoAT'));